export const SUMMARY_TAB_EVENT_KEY = "summary";

export const SUMMARY_TAB_LABEL = "Summary";

export const SUMMARY_TOTAL_HEADER = "Total";

export const SUMMARY_KPI_COLUMN_HEADER = "KPI";

export const SUMMARY_UNSAVED_BANNER =
  "Save your drafts to refresh this summary.";

export const SUMMARY_EMPTY_STATE =
  "No subgroup summary is available for this template yet.";
